import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Services = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchServices();
  }, []);

  const fetchServices = async () => {
    try {
      const response = await axios.get(`${API}/services`);
      setServices(response.data);
    } catch (error) {
      console.error('Error fetching services:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSelectPackage = (service) => {
    // Scroll to contact section
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
      
      // Pre-fill service in contact form
      setTimeout(() => {
        const serviceSelect = document.querySelector('select[name="service"]');
        if (serviceSelect) {
          serviceSelect.value = service.id;
          serviceSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }, 1000);
    }
  };

  if (loading) {
    return (
      <section className="py-20 bg-gradient-to-br from-slate-900 to-blue-900 relative overflow-hidden">
        <div className="container mx-auto px-4">
          <div className="text-center">
            <div className="text-white text-xl">Loading services... 🔄</div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="py-20 bg-gradient-to-br from-slate-900 to-blue-900 relative overflow-hidden" id="services">
      {/* Animated background */}
      <div className="absolute inset-0">
        <div className="absolute top-1/4 right-1/4 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-1/4 left-1/4 w-80 h-80 bg-orange-500/10 rounded-full blur-3xl animate-pulse delay-1000"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-6xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <Badge className="bg-blue-100 text-blue-800 border-blue-200 mb-4 px-4 py-2">
              Services
            </Badge>
            <h2 className="text-4xl md:text-6xl font-black text-white mb-6">
              Kya Kya Banata Hai Apun! 🛠️
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Logo se lekar complete brand identity tak - sab kuch milega ek hi jagah! Professional quality, desi swag! 🔥
            </p>
          </div>

          {/* Services Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {services.map((service, index) => (
              <Card 
                key={service.id} 
                className={`bg-white/5 backdrop-blur-md border-white/10 hover:bg-white/10 transition-all duration-500 transform hover:-translate-y-4 hover:shadow-2xl ${
                  service.popular ? 'ring-2 ring-orange-500 ring-opacity-50' : ''
                }`}
                style={{
                  animationDelay: `${index * 0.1}s`
                }}
              >
                {service.popular && (
                  <div className="absolute -top-3 left-1/2 transform -translate-x-1/2 z-10">
                    <Badge className="bg-gradient-to-r from-orange-500 to-red-500 text-white px-3 py-1 text-sm font-bold">
                      🔥 Most Popular
                    </Badge>
                  </div>
                )}
                
                <CardHeader className="text-center pb-4">
                  <div className="text-6xl mb-4 animate-bounce">
                    {service.icon}
                  </div>
                  <CardTitle className="text-white text-xl font-bold mb-2">
                    {service.title}
                  </CardTitle>
                  <p className="text-orange-400 font-semibold text-sm">
                    {service.subtitle}
                  </p>
                </CardHeader>

                <CardContent className="space-y-4">
                  <p className="text-gray-300 text-sm leading-relaxed">
                    {service.description}
                  </p>

                  <div className="text-center py-4">
                    <div className="text-3xl font-black text-white mb-1">
                      {service.price}
                    </div>
                    <div className="text-gray-400 text-sm">Starting Price</div>
                  </div>

                  <ul className="space-y-2 text-sm">
                    {service.features.map((feature, idx) => (
                      <li key={idx} className="flex items-center text-gray-300">
                        <div className="w-2 h-2 bg-blue-400 rounded-full mr-3 flex-shrink-0"></div>
                        {feature}
                      </li>
                    ))}
                  </ul>

                  <Button 
                    onClick={() => handleSelectPackage(service)}
                    className={`w-full mt-6 ${
                      service.popular 
                        ? 'bg-gradient-to-r from-orange-500 to-red-500 hover:from-orange-600 hover:to-red-600' 
                        : 'bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700'
                    } text-white font-semibold py-3 transform transition-all duration-300 hover:scale-105 shadow-lg`}
                  >
                    Select Package 🚀
                  </Button>
                </CardContent>
              </Card>
            ))}
          </div>

          {/* Bottom CTA */}
          <div className="text-center mt-16">
            <div className="bg-gradient-to-r from-blue-600/20 to-purple-600/20 backdrop-blur-md rounded-2xl p-8 border border-white/10">
              <h3 className="text-2xl font-bold text-white mb-4">
                Custom Package Chahiye? 🤔
              </h3>
              <p className="text-gray-300 mb-6 max-w-2xl mx-auto">
                Agar koi special requirement hai ya combo package banwana hai, direct DM kar! Custom quote deta hun bilkul free mein! 💬
              </p>
              <Button 
                size="lg" 
                onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
                className="bg-gradient-to-r from-orange-500 to-red-500 hover:from-orange-600 hover:to-red-600 text-white px-8 py-4 text-lg font-semibold transform hover:scale-105 transition-all duration-300"
              >
                Get Custom Quote 💰
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;